<template>
  <div class="text-start">

    <nav class="border-b border-gray-300 px-2 md:px-0 py-2 mb-4" v-if="breadcrumb">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'vouchers'}">Vouchers</router-link>
            <span class="mx-2">/</span>
            <span>Generate vouchers</span>
          </div>
          <div class="text-xl">
            Generate vouchers
          </div>
        </div>
      </div>
    </nav>
    <div class="">
      <div class="">
        <div class="bg-white p-4 border rounded shadow-sm">
          <div class="">
            <label class="block text-sm ">Voucher group name<span class="text-red-700">*</span></label>
            <input aria-label="Venue name" type="text" required v-model="name" :class="inputClass"
                   placeholder="Voucher group name"/>
          </div>
          <div class="flex my-3 justify-between">
            <div class="w-full mr-2">
              <label class="block text-sm leading-5 ">Value</label>
              <input aria-label="value" name="phone_number" type="number" v-model="face_value" :class="inputClass"
                     placeholder="Voucher value"/>
            </div>
            <div class="w-full ml-2">
              <label class="block text-sm leading-5 ">Valid Till</label>
              <date-picker v-model="valid_till" valueType="format"></date-picker>
            </div>
          </div>
          <div class="my-3">
            <label class="block text-sm leading-5 ">Description</label>
            <textarea v-model="description" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                      placeholder="Describe..."></textarea>
          </div>
          <div class="mt-6">
            <button type="submit" v-on:click="saveVoucher" class="rounded px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
              {{ voucherId == null ? "Create" : "Update" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/services/Utils";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: "GenerateVouchers",
  components: { DatePicker},
  data() {
    return {
      name: '',
      face_value: '',
      valid_till: '',
      description: '',
      loading: false,
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    voucherId: String,
  },
  mounted() {
    this.$root.$on("venue_created", () => {
      this.$router.replace("/venues");
    });
  },
  methods: {
    saveVoucher() {
      this.loading = true;
      this.errors = [];
      if (this.name == null || this.name === '')
        this.errors.push("Name field is required.");
      if (this.valid_till == null || this.address === '')
        this.errors.push("Voucher validity is required.");
      if (this.face_value == null || this.face_value === '')
        this.errors.push("Voucher value is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      let params = {
        name: this.name,
        face_value: this.face_value,
        valid_till: this.valid_till,
        description: this.description,
        organization_id: this.$store.getters.orgId
      };

      let request = this.voucherId == null ? this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/vouchers', params) :
          this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/vouchers/' + this.voucherId, params)

      request.then((result) => {
        this.$root.$emit('alert_success', [result.data.data.message]);

      }).catch((error) => {
        if (error.response != null && error.response.status === 422)
          this.errors = Utils.processError(error.response.data);
        else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });

    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    }
  }
}
</script>
<style scoped> .mx-datepicker {
  width: 100% !important;
}
</style>